import { render, staticRenderFns } from "./ImageUploader.vue?vue&type=template&id=567de3de&scoped=true&"
import script from "./ImageUploader.vue?vue&type=script&lang=js&"
export * from "./ImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./ImageUploader.vue?vue&type=style&index=0&id=567de3de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567de3de",
  null
  
)

export default component.exports